import type { HtmlFile } from '../../../types'
import type { TagRegistry } from '../../../tagRegistry'
import { parseStructureToAst } from './structureParser'
import { convertStructureAstToCore, type StructureCoreExport } from './structureConverter'

export const importStructure = (structure: HtmlFile, registry: TagRegistry): StructureCoreExport => {
    const doc = parseStructureToAst(structure)
    return convertStructureAstToCore(doc, registry)
}
